import { CSSProperties } from "react";
import { BreakpointStyles, Screens } from "./types";
import { theme } from "../theme";
import { CSSObject } from "@emotion/react";

export const createResponsiveStyles = ({
  base,
  ...breakpointStyles
}: BreakpointStyles) => {
  return {
    ...base,
    ...Object.entries(breakpointStyles).reduce(
      (final, [screen, styles]: [string, CSSProperties | CSSObject]) => {
        if (styles) {
          final[`@media (min-width: ${theme.screens[screen as Screens]})`] = {
            ...styles,
          };
        }
        return final;
      },
      {} as { [key: string]: CSSProperties | CSSObject },
    ),
  };
};
